// Общие утилиты фронтенда

// Чтение csrf_token из cookie и бэкенд выставляет её после логина
export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
}

// Маппинг языка i18next ('ru' | 'kk' | 'en') в BCP-47 locale для Intl/toLocaleDateString
const I18N_TO_INTL_LOCALE = {
  ru: 'ru-RU',
  kk: 'kk-KZ',
  en: 'en-US',
};

export function getIntlLocale(i18nLanguage) {
  return I18N_TO_INTL_LOCALE[i18nLanguage] || I18N_TO_INTL_LOCALE.ru;
}

// Политика паролей (дублирует проверку в BFF: bff/utils.py is_password_strong).
// Белый список: буквы, цифры, пунктуация, пробел, знаки + = < > $ ^ ` и т.п.
// Эмодзи, иконки, управляющие и невидимые символы — запрещены.
const PASSWORD_ALLOWED_RE = /^[\p{L}\p{N}\p{P}\p{Zs}\p{Sm}\p{Sc}\p{Sk}]*$/u;
const NON_BMP_RE = /[\u{10000}-\u{10FFFF}]/u;

export function isPasswordStrong(password) {
  return (
    password.length >= 8 &&
    PASSWORD_ALLOWED_RE.test(password) &&
    !NON_BMP_RE.test(password) &&
    /\p{Lu}/u.test(password) &&
    /\p{Nd}/u.test(password)
  );
}
